import curry from 'just-curry-it';

const minmax = curry((min: number, max: number, n: number) =>
  Math.max(min, Math.min(n, max)),
);

export default minmax;
